import { useQuery } from '@tanstack/react-query';
import { queryKeys, type ProductsListFilters } from '@/core/data-fetching/queryKeys';
import { productsService } from '../api/products.service';
import type { BillingType } from '../api/products.service';

export function useProductsListQuery(filters: ProductsListFilters) {
  return useQuery({
    queryKey: queryKeys.products.list(filters),
    queryFn: () =>
      productsService.list({
        page: filters.page,
        limit: filters.limit,
        search: filters.search,
        active: filters.active,
        billingType: filters.billingType ? (filters.billingType as BillingType) : undefined,
      }),
  });
}
